import {
  IInvitationCreatePayload,
  IInvitationGetFilters,
} from '@/types/invitation'
import qs from 'qs'
import { ApiService } from './ApiService'

export class InvitationService extends ApiService {
  static RESOURCE_PATH = '/invitations'

  static async getInvitations(filters: IInvitationGetFilters = {}) {
    const queryString = qs.stringify(filters, {
      encode: false,
      arrayFormat: 'repeat',
    })

    return ApiService.get(`${InvitationService.RESOURCE_PATH}?${queryString}`)
  }

  static async postInvitation(payload: IInvitationCreatePayload) {
    return ApiService.post(InvitationService.RESOURCE_PATH, payload)
  }
}
